// =============================================================================
// MeuDriver — Brand logo
// =============================================================================
// Lockup único da marca. Antes de existir, cada tela desenhava o próprio logo:
// header e layouts usavam o wordmark (`/logo.png`), enquanto login, cadastro,
// reset de senha e 404 desenhavam um ícone de carro numa caixa arredondada com
// o texto "MeuDriver" ao lado — três variações de cor e tamanho diferentes.
// Toda a aplicação passa por aqui.

import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface BrandLogoProps {
  /** `true` quando o logo fica sobre fundo escuro — usa o wordmark branco. */
  onDark?: boolean
  /** Altura do wordmark. Padrão: `h-8`. */
  className?: string
  /** Envolve o logo num link. Passe `null` para renderizar sem link. */
  to?: string | null
}

export function BrandLogo({ onDark = false, className, to = '/' }: BrandLogoProps) {
  const img = (
    <img
      src={onDark ? '/logo.png' : '/logo-dark.png'}
      alt="MeuDriver"
      className={cn('w-auto block', className ?? 'h-8')}
    />
  )

  if (to === null) return img

  return (
    <Link to={to} className="inline-flex items-center shrink-0">
      {img}
    </Link>
  )
}

export default BrandLogo
